import { useCallback } from 'react';
import { actions, TableState, TableInstance } from 'react-table';

actions.clearSelectedRows = 'clearSelectedRows';

function reducer(state: TableState, action: Record<string, string>) {
  if (action.type === actions.clearSelectedRows) {
    return {
      ...state,
      selectedRowIds: {},
    };
  }
}

function useInstance(instance: TableInstance) {
  const { dispatch } = instance;
  const clearAllSelectedRows = useCallback(
    () => dispatch({ type: actions.clearSelectedRows }),
    [dispatch]
  );

  Object.assign(instance, { clearAllSelectedRows });
}

/**
 * A small extension to add a helper method to clear all
 * selected rows, even out of scope of pagination.
 */
export function useClearAllSelectedRows(hooks) {
  hooks.stateReducers.push(reducer);
  hooks.useInstance.push(useInstance);
}
